(function(angular, module) {var ListSortController, listSortDirective,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ListSortController = (function() {

  /* @ngInject */
  function ListSortController($element) {
    this.refreshViewValue = bind(this.refreshViewValue, this);
    this.render = bind(this.render, this);
    this.ngModel = $element.controller('ngModel');
    this.ngModel.$render = this.render;
  }

  ListSortController.prototype.findOption = function(value) {
    var i, len, opt, ref;
    ref = this.options;
    for (i = 0, len = ref.length; i < len; i++) {
      opt = ref[i];
      if (opt.value === value) {
        return opt;
      }
    }
  };

  ListSortController.prototype.render = function() {
    var ref, viewValue;
    viewValue = this.ngModel.$viewValue;
    if ((viewValue != null ? viewValue.length : void 0) > 0) {
      this.ascending = viewValue[0] !== '-';
      this.column = this.ascending ? viewValue : viewValue.slice(1);
      this.label = (ref = this.findOption(this.column)) != null ? ref.label : void 0;
    }
  };

  ListSortController.prototype.changeColumn = function(option) {
    this.ascending = option.desc == null;
    this.refreshViewValue();
  };

  ListSortController.prototype.changeDirection = function(ascending) {
    this.refreshViewValue();
  };

  ListSortController.prototype.refreshViewValue = function() {
    var viewValue;
    viewValue = this.column;
    if (!this.ascending) {
      viewValue = "-" + viewValue;
    }
    this.ngModel.$setViewValue(viewValue);
    this.render();
  };

  return ListSortController;

})();

listSortDirective = function() {
  return {
    restrict: 'E',
    templateUrl: 'util/widgets/listSort',
    require: 'ngModel',
    scope: {
      options: '=',
      column: '=?',
      direction: '=?'
    },
    controller: ListSortController,
    controllerAs: 'ctrl',
    bindToController: true
  };
};

module.directive('listSort', listSortDirective);
})(angular, angular.module("dyb.util.widgets"));